import React from "react";
import { Box, Button, Typography, withStyles } from "@material-ui/core";
import { Upload } from "antd";
import { uploadStatusEnum } from "../../../../components/single-registry/enums/status-upload";
import { UploadFileBase } from "../../../../components/single-registry/upload/UploadFile/UploadFile";
import {
  CloudGradientIcon,
  DV3DocumentDownloadIcon,
  IconUpload,
  UploadFolderProcessingIcon,
} from "../../../../common/icons";
import HUBContext from "../../../../services/HUBContext";
import { defineMessages, injectIntl } from "react-intl";
import {
  acceptedExtensionsExt,
  CustomLinearProgress,
} from "../../../../components/single-registry/upload/UploadFile/constants";
import singleRegistryTheme from "../../../../components/single-registry/theme";
import { translations } from "./constants";
import TemplateDownloadModalWidget from "../TemplateDownloadModalWidget/TemplateDownloadModalWidget";
import { stylesFixed } from "./UploadFileWidget.styles";
import { stylesTheme } from "../../../../components/single-registry/upload/UploadFile/UploadFile.styles";

const messages = defineMessages(translations);

const styles = (theme) => stylesTheme;

export class UploadFileWidget extends UploadFileBase {
  render() {
    const {
      hasErrorUpload,
      uploadErrorMessage,
      percent,
      status,
      companyId,
      intl,
    } = this.props;

    const isUploadingInProgress =
      status === uploadStatusEnum.SENDING ||
      status === uploadStatusEnum.COMPLETED;

    return (
      <Box>
        <input
          type="file"
          ref={this.fileInputRef}
          accept={acceptedExtensionsExt.join(",")}
          style={{ display: "none" }}
          onChange={this.handleHiddenInputChange}
        />

        <React.Fragment>
          <Box style={stylesFixed.boxHeader}>
            <Typography style={stylesFixed.title}>
              {intl.formatMessage(messages.title)}
            </Typography>

            <Typography style={stylesFixed.subtitle}>
              {intl.formatMessage(messages.subtitle)}
            </Typography>
          </Box>

          <Upload.Dragger
            ref={this.inputRef}
            {...this.draggerConfig}
            style={stylesFixed.uploadDragger}
          >
            <div className="wrapper-upload" style={stylesFixed.wrapperUpload}>
              <Box sx={stylesFixed.boxUploadProgress}>
                {isUploadingInProgress ? (
                  <CloudGradientIcon />
                ) : (
                  <UploadFolderProcessingIcon />
                )}
              </Box>

              {hasErrorUpload ? (
                <React.Fragment>
                  {uploadErrorMessage.split("\n")?.map((message, key) => (
                    <Typography
                      key={key}
                      style={stylesFixed.errorMessage}
                      data-testid="upload-backend-error"
                    >
                      {message}
                    </Typography>
                  ))}
                </React.Fragment>
              ) : null}

              <p style={stylesFixed.draggerTitle}>
                {intl.formatMessage(messages.draggerTitle)}
              </p>

              <Box style={stylesFixed.selectedFileName}>
                {this.state.selectedFile && this.state.selectedFile?.name
                  ? this.state.selectedFile?.name
                  : null}
              </Box>

              {typeof percent === "number" && isUploadingInProgress && (
                <Box style={stylesFixed.percentProgress}>
                  <CustomLinearProgress variant="determinate" value={percent} />

                  <span>{percent}%</span>
                </Box>
              )}

              {!isUploadingInProgress && (
                <p style={stylesFixed.acceptedFiles}>
                  {intl.formatMessage(messages.acceptedFiles)}
                </p>
              )}

              <Box>
                {this.state.selectedFile && this.state.selectedFile?.name ? (
                  <Button
                    style={stylesFixed.replaceFileButton}
                    className="v3-button"
                    onClick={this.handleOpenFileDialog}
                    color="primary"
                  >
                    <div style={stylesFixed.replaceFileContent}>
                      <IconUpload fillcolor="#1E293B" />

                      <span style={stylesFixed.replaceFileInfo}>
                        {intl.formatMessage(messages.replaceFile)}
                      </span>
                    </div>
                  </Button>
                ) : (
                  <Button
                    style={stylesFixed.importFileButton}
                    className="v3-button black"
                    onClick={this.handleOpenFileDialog}
                    color="primary"
                  >
                    <div style={stylesFixed.importFileContent}>
                      <IconUpload fillcolor="#1E293B" />

                      <span style={stylesFixed.importFileInfo}>
                        {intl.formatMessage(messages.importFile)}
                      </span>
                    </div>
                  </Button>
                )}
              </Box>

              <Box
                onClick={this.handleOpenTemplateModal}
                sx={stylesFixed.downloadTemplateBox}
                tabIndex={0}
                role="button"
              >
                {intl.formatMessage(messages.downloadTemplate)}

                <DV3DocumentDownloadIcon color="#F72717" />
              </Box>

              <TemplateDownloadModalWidget
                locale={this.context.locale}
                open={this.state.isTemplateModalOpen}
                onClose={this.handleCloseTemplateModal}
                companyId={companyId}
                integratorsSolutionsCode={this.props.integratorsSolutionsCode}
              />
            </div>
          </Upload.Dragger>
        </React.Fragment>
      </Box>
    );
  }
}

UploadFileWidget.contextType = HUBContext;

export default withStyles(styles, { defaultTheme: singleRegistryTheme })(
  injectIntl(UploadFileWidget),
);
